import { useFormik } from 'formik'
import React from 'react'
import { useMutation } from '@tanstack/react-query'
// import FileSelectInput from './FileSelectInput'
import * as Yup from 'yup'
import { Modal2 } from './Modal'
import { SAMPLE_UPLOAD_FILE_LINKS } from '../consts'
import { useTranslation } from 'react-i18next'
import { uploadFile, import_data } from '@velocity/shared'

type Props = {
  open: string
  setOpen: (val: any) => void
  model: string
  title: string
}
export function ImportData({ open, setOpen, model, title }: Props) {
  const { t } = useTranslation()
  const mutation = useMutation({
    mutationFn: import_data,
    onSuccess: () => {
      setOpen(false)
      formik.resetForm()
    }
  })
  const initialValues: any = { model, media: '' }
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: async (values) => {
      let v = { ...values }
      if (v.media) {
        const res = await uploadFile(values.media, 'import/' + model)
        if (res.status) v.media = res.data
        else delete v.media
      }
      mutation.mutate(v)
    },
    validationSchema: Yup.object({
      media: Yup.mixed().required().label('File')
    })
  })
  const buttons = [
    {
      title: 'Upload',
      loading: mutation.isPending,
      type: 'submit',
      onClick: formik.handleSubmit
    },
    {
      title: 'Cancel',
      onClick: () => setOpen(false),
      btnStyle: 'outline'
    }
  ]
  return (
    <Modal2
      open={open === 'import'}
      setOpen={setOpen}
      title={t(open + ' ' + title + 's').toUpperCase()}
      buttons={buttons}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className='grid-cols-2 gap-4 sm:grid'>
          {/* <FileSelectInput
            meta={formik.getFieldMeta('media')}
            name='media'
            label='Upload CSV File'
            onChange={(file: any) => formik.setFieldValue('media', file)}
            accept='.csv'
          /> */}
          <div className='text-sm'>
            <a
              className='text-primary text-lg'
              href={SAMPLE_UPLOAD_FILE_LINKS[model]}
              download={true}
            >
              {t('Download Sample File')}
            </a>
            <ul>
              <li>{t('Download the sample file and fill the data')}</li>
              <li>{t('Do not change the column headers')}</li>
            </ul>
          </div>
        </div>
      </form>
    </Modal2>
  )
}
